export default __webpack_public_path__ + "static/media/fitness.fa553081.svg";